<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'Order': 'Pedido',
      'My Plan': 'Meu Plano',
      'Payment Method': 'Forma de Pagamento',
      'Order Date': 'Data do Pedido',

      'Items': 'Itens',
      'Item': 'Item',
      'Total': 'Total',
      'TOTAL': 'TOTAL',
      'Price': 'Preço',
      'Qty': 'Qtd',
      'Value': 'Valor',
      'Status': 'Status',
      'Date': 'Data',

      'Switch plans': 'Trocar de Plano',
      'Current choice': 'Escolha Atual',
      'Choose': 'Escolher',
      'Plan name': 'Nome do Plano',
      'Plans': 'Planos',

      'Awaiting payment': 'Aguardando pagamento',
      'Payment confirmed': 'Pagamento confirmado',

      'Address': 'Endereço',
      'Send exactly value to make payment': 'Envie exatamente o valor para efetuar o pagamento',

      'The order was not found.': 'O pedido não foi encontrado.',

      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.',
      'No records found.': 'Nenhum registro encontrado.',

      'Payment Details': 'Detalhes do pagamento',
      'Read the qrcode above or': 'Leia o qrcode acima ou',
      'Open your bank app or payment app.': 'Abra o app do seu banco ou seu app de pagamentos.',
      'Look for the option to pay with pix.': 'Busque a opção de pagar com pix.',
      'Copy and paste the following code.': 'Copie e cole o seguinte código.',
      'Copy': 'Copiar',
      'Copied!': 'Copiado!',
      'Click here to pay': 'Clique aqui para pagar',
      'Account Balance': 'Saldo em Conta',
      'Do you want to pay this order with your balance?': 'Deseja pagar esse pedido com o seu saldo?',
      'Your current balance is': 'Seu saldo atual é de',
      'and your balance after payment will be': 'e seu saldo após o pagamento será de',
      'Confirm': 'Confirmar',
      'You currently do not have enough balance to pay for this order.': 'No momento você não possui saldo suficiente para realizar o pagamento do pedido.',
      'The order was paid successfully.': 'O pedido foi pago com sucesso.',
    },
    es: {
      'Order': 'Pedido',
      'My Plan': 'Mi Plan',
      'Payment Method': 'Forma de Pago',
      'Order Date': 'Fecha del Pedido',

      'Items': 'Artículos',
      'Item': 'Artículo',
      'Total': 'Total',
      'TOTAL': 'TOTAL',
      'Price': 'Precio',
      'Qty': 'Cant.',
      'Value': 'Valor',
      'Status': 'Estado',
      'Date': 'Fecha',

      'Switch plans': 'Cambiar de Plan',
      'Current choice': 'Elección Actual',
      'Choose': 'Elegir',
      'Plan name': 'Nombre del Plan',
      'Plans': 'Planes',

      'Awaiting payment': 'En espera de pago',
      'Payment confirmed': 'Pago confirmado',

      'Address': 'Dirección',
      'Send exactly value to make payment': 'Envía exactamente el monto para realizar el pago',

      'The order was not found.': 'El pedido no fue encontrado.',

      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtalo de nuevo más tarde.',
      'No records found.': 'No se encontraron registros.',

      'Payment Details': 'Detalles del pago',
      'Read the qrcode above or': 'Lee el código QR arriba o',
      'Open your bank app or payment app.': 'Abre la app de tu banco o tu app de pagos.',
      'Look for the option to pay with pix.': 'Busca la opción de pagar con pix.',
      'Copy and paste the following code.': 'Copia y pega el siguiente código.',
      'Copy': 'Copiar',
      'Copied!': '¡Copiado!',
      'Click here to pay': 'Haz clic aquí para pagar',
      'Account Balance': 'Saldo en Cuenta',
      'Do you want to pay this order with your balance?': '¿Deseas pagar este pedido con tu saldo?',
      'Your current balance is': 'Tu saldo actual es de',
      'and your balance after payment will be': 'y tu saldo después del pago será de',
      'Confirm': 'Confirmar',
      'You currently do not have enough balance to pay for this order.': 'Actualmente no tienes saldo suficiente para pagar este pedido.',
      'The order was paid successfully.': 'El pedido se pagó con éxito.',
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      loading: true,
      errored: false,
      empty: false,
      plans: null,

      order: {
        id: this.$route.params.id,
        date: null,

        subtotal: '0.00',
        discount: '0.00',
        shipping: {
          method: '',
          value: '0.00',
          address: {
            zipcode: '',
            address: '',
            number: '',
            complement: '',
            district: '',
            city: '',
            state: '',
          }
        },
        payment: {
          methods: {},
          list: [],
        },

        total: '0.00',

        items: null,
        status: null,
      },

      balance: {
        modal: false,
        loading: false,
        pay: '0.00',
        total: '0.00',
      },

      pix: {
        text: '',
        image: '',
      },
    };
  },
  methods: {
    getOrder() {
      if (this.order.id) {
        api
          .get('store/orders/' + this.order.id)
          .then(response => {
            if (response.data.status == 'success') {
              this.order = response.data.order

              this.loading = false

              if (this.order.payment.status == 'pending' && this.order.payment.methods.pix) {
                this.gerarPix();
              }
            } else {
              this.empty = true
              this.message = this.t(response.data.message)
            }
          })
          .catch(error => {
            this.errored = error
          })
          .finally(() => {
            this.getBalance();
          })
      }
    },
    gerarPix() {
      api
        .post('store/orders/' + this.order.id + '/pix')
        .then(response => {
          if (response.data.status == 'success') {
            this.pix.text  = response.data.pix.text;
            this.pix.image = response.data.pix.image;
          }
        })
    },
    getBalance() {
      api
        .get('wallet/balance/network')
        .then(response => {
          if (response.data.status == 'success') {
            this.balance.total = response.data.balance
            this.balance.pay = parseFloat(this.balance.total) - parseFloat(this.order.total);
          }
        })
    },
    payOrder() {
      this.balance.loading = true;

      api
        .post('wallet/pay/' + this.order.id)
        .then(response => {
          if (response.data.status == 'success') {
            this.$toast.success(this.t('The order was paid successfully.'))
            this.getOrder();
          }
        })
        .catch(error => {
          if (error) {
            this.balance.loading = false;
          }
        })
        .finally(() => {
          this.balance.loading = false;
        })
    }
  },
  mounted() {
    this.getOrder()
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/plans">{{ t('My Plan') }}</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">{{ t('Order') }}</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Order') }}</h3>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-10 mx-auto">
        <div class="card">
          <div class="card-body p-4">
            <div v-if="errored">{{ t('We apologize, we are unable to retrieve information at this time. Please try again later.') }}</div>
            <div v-else-if="empty">{{ t('No records found.') }}</div>
            <div v-else class="p-2">
              <div class="d-flex">
                <h4 class="mb-0 font-size-15 flex-fill">
                  #{{ order.id }}
                </h4>
                <h4 class="mb-0 font-size-15 flex-fill text-right">
                  {{ order.date }}
                </h4>
              </div>
              <hr />
              <div class="table-responsive">
                <table class="table table-nowrap">
                  <thead>
                    <tr>
                      <th class="border-0 text-uppercase text-center">{{ t('Item') }}</th>
                      <th class="border-0 text-uppercase text-center">{{ t('Total') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(td, index) in order.items" :key="index">
                      <td class="text-center">{{ td.name }} </td>
                      <td class="text-center">{{ td.subtotal | currency }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row mt-5">
                <div class="col-lg-6 mb-4">
                  <h3 class="font-size-16 mb-3">{{ t('Payment Details') }}</h3>
                  <div class="table-responsive">
                    <table class="table table-nowrap table-borderless">
                      <tbody>
                        <tr>
                          <td class="px-0 py-1 font-weight-bold">{{ t('TOTAL') }}</td>
                          <td class="px-0 py-1 font-weight-bold text-right">{{ order.total | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <h3 class="font-size-16 mb-2">{{ t('Status') }}</h3>
              <div v-for="(td, index) in order.status" :key="index">
                {{ td.date }} — {{ t(td.status) }}
              </div>
              <b-tabs v-if="order.payment.status === 'pending'" justified nav-class="nav-tabs-custom mt-5" content-class="p-3 text-muted">
                <b-tab v-for="(pay, method) in order.payment.methods" :key="method">
                  <template v-slot:title>{{ pay.name }}</template>
                  <div v-if="method == 'pix'" class="text-center">
                    <img v-if="pix.image" style="width: 250px" :src="'data:image/png;base64,' + pix.image" />
                    <p>{{ t('Read the qrcode above or') }}</p>
                    <ol class="text-left">
                      <li>{{ t('Open your bank app or payment app.') }}</li>
                      <li>{{ t('Look for the option to pay with pix.') }}</li>
                      <li>{{ t('Copy and paste the following code.') }}</li>
                    </ol>
                    <div class="border rounded p-3 mb-3 text-left">
                      {{ pix.text }}
                    </div>
                    <button class="btn btn-default" v-clipboard:copy="pix.text" v-on:click="$toast.success(t('Copied!'))">
                      <i class="bx bx-copy font-size-18 align-middle"></i>
                      {{ t('Copy') }}
                    </button>
                  </div>
                  <div v-else-if="method == 'mercadopago'" class="text-center">
                    <img class="mt-4 mb-5" height="50px" src="@/assets/images/payments/logo-mercadopago.svg"><br>
                    <a target="_blank" class="btn btn-default btn-lg" :href="pay.url">{{ t('Click here to pay') }}</a>
                  </div>
                </b-tab>
                <b-tab key="balance" :active="balance.pay >= 0">
                  <template v-slot:title>{{ t('Account Balance') }}</template>
                  <div class="mt-4 text-center">
                    <template v-if="balance.pay >= 0">
                      <p>{{ t('Do you want to pay this order with your balance?') }}</p>
                      <p>{{ t('Your current balance is') }} <strong>{{ balance.total | currency }}</strong> {{ t('and your balance after payment will be') }} <strong>{{ balance.total - order.total | currency }}</strong>.</p>
                      <button class="btn btn-default mr-3" v-on:click="payOrder()">
                        {{ t('Confirm') }}
                        <b-spinner v-if="balance.loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
                      </button>
                    </template>
                    <template v-else>
                      <p>{{ t('You currently do not have enough balance to pay for this order.') }}</p>
                    </template>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>